import { BaseWidgetContainer } from 'components/page/BaseLandingPage';
import { SpinnerArea } from 'components/spinner/SpinnerArea';
import styled from 'styled-components';
import { primaryText, secondaryText } from 'styles/theme';

export const Container = styled(BaseWidgetContainer)`
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const Title = styled.h2`
    color: ${primaryText};
    font-size: 2.4rem;
    font-weight: 500;
    line-height: 2.8rem;
    margin: 0;
`;

export const CountText = styled.span`
    color: ${primaryText};
`;

export const PercentText = styled.span`
    color: ${secondaryText};
    margin-left: 0.4rem;
`;

export const StyledSpinnerArea = styled(SpinnerArea)`
    padding: 4rem 0;
`;
